import { connect } from 'react-redux';

import type {
  PersonalisationOptionsDispatchProps,
  PersonalisationOptionsStateProps,
} from 'src/components/organisms/Personalisation/components/PersonalisationOptions/PersonalisationOptions';
import { PersonalisationOptions } from 'src/components/organisms/Personalisation/components/PersonalisationOptions/PersonalisationOptions';
import {
  selectNumberOfRequiredOptions,
  selectOptions,
  selectOutstandingOptions,
  selectTrackedEvents,
} from 'src/redux/basket/selectors';
import { actions as basketActions } from 'src/redux/basket/slice';
import type {
  InteractionErrorTrackingEvent,
  InteractionTrackingEvent,
  ProgressTrackingEvent,
  SelectionPayload,
} from 'src/redux/basket/types';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import type { AppThunkDispatch } from 'src/redux/store';

const mapStateToProps = (state: ReduxApplicationState): PersonalisationOptionsStateProps => {
  return {
    options: selectOptions(state),
    outstandingSelections: selectOutstandingOptions(state),
    totalRequiredOptions: selectNumberOfRequiredOptions(state),
    trackedEvents: selectTrackedEvents(state),
  };
};

const mapDispatchToProps = (dispatch: AppThunkDispatch): PersonalisationOptionsDispatchProps => {
  return {
    deselectOption: (payload: SelectionPayload) => dispatch(basketActions.deselectOption(payload)),
    selectOption: (payload: SelectionPayload) => dispatch(basketActions.selectOption(payload)),
    trackInteraction: (payload: InteractionTrackingEvent) =>
      dispatch(basketActions.trackInteraction(payload)),
    trackProgressMilestone: (payload: ProgressTrackingEvent) =>
      dispatch(basketActions.trackProgressMilestone(payload)),
    trackInteractionError: (payload: InteractionErrorTrackingEvent) =>
      dispatch(basketActions.trackInteractionError(payload)),
  };
};

export const PersonalisationContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PersonalisationOptions);
